import React, { useState } from "react";
// MUI components
import {
  Accordion,
  AccordionSummary,
  Typography,
  Radio,
  FormControlLabel,
  Button,
} from "@mui/material";
// MUI Icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// react admin
import { useDataProvider, useNotify, useRedirect } from "react-admin";
// loader
import { Loader } from "../../Loader";

// RTP Configurations for Keno games
const rtpConfigs = [85, 88, 90, 92, 95, 98];

const KenoGameRTPForm = ({ selectedGame, editMode = false, existingData = null }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();

  const [loading, setLoading] = useState(false);
  const [selectedRTP, setSelectedRTP] = useState(
    editMode && existingData ? existingData.gameRtp.toString() : "85"
  );
  const [expanded, setExpanded] = useState(null);

  // State to track whether each RTP is active or not
  const [activeRTP, setActiveRTP] = useState(
    rtpConfigs.reduce((acc, rtp) => {
      if (editMode && existingData) {
        acc[rtp] = rtp === existingData.gameRtp;
      } else {
        acc[rtp] = rtp === 85; // Default active RTP is 85
      }
      return acc;
    }, {})
  );

  // Handle RTP selection
  const handleRTPChange = (event) => {
    setSelectedRTP(event.target.value);
    setActiveRTP((prev) => ({
      ...prev,
      [event.target.value]: true,
    }));
    // Deactivate other RTPs
    rtpConfigs
      .filter((rtp) => rtp !== parseInt(event.target.value))
      .forEach((rtp) => {
        setActiveRTP((prev) => ({
          ...prev,
          [rtp]: false,
        }));
      });
  };

  // Handle accordion expand
  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Submit function for creating Keno RTP
  const handleSubmit = async () => {
    setLoading(true);

    // Find the active RTP
    const activeRTPKey = Object.keys(activeRTP).find(
      (rtp) => activeRTP[rtp] === true
    );

    // Format data in kenoReelName array structure (similar to Firelink pattern)
    const kenoReelNameData = [
      {
        rtpPercentage: Number(activeRTPKey),
        isActive: true,
      }
    ];

    const formattedData = {
      gameId: selectedGame?.id,
      gameName: selectedGame?.name,
      gameRtp: Number(activeRTPKey),
      kenoReelName: kenoReelNameData, // Array structure for Keno column
    };

    try {
      let response;
      if (editMode && existingData) {
        // Update existing Keno RTP
        response = await dataProvider.update("kenoGameRtp", {
          id: existingData.id,
          data: formattedData,
        });
      } else {
        // Create new Keno RTP
        response = await dataProvider.create("kenoGameRtp", {
          data: formattedData,
        });
      }

      if (response) {
        notify(
          editMode
            ? "Keno GameRTP updated successfully!"
            : "Keno GameRTP created successfully!",
          { type: "success" }
        );
        redirect("/gameRtp");
        setLoading(false);
      }
    } catch (error) {
      notify(error.message || "An error occurred", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div>
        {rtpConfigs.map((rtp, index) => (
          <Accordion
            key={rtp}
            expanded={expanded === `panel${index}`}
            onChange={handleExpand(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <FormControlLabel
                value={rtp.toString()}
                control={
                  <Radio
                    checked={selectedRTP === rtp.toString()}
                    onChange={handleRTPChange}
                  />
                }
                label={<Typography>{rtp}% RTP</Typography>}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.stopPropagation()}
              />
            </AccordionSummary>
          </Accordion>
        ))}

       {/* Submit Button */}
            <Button 
              variant="contained" 
              color="primary" 
               onClick={handleSubmit}
              disabled={loading}
              sx={{ mt: 3 }}
            >
              Submit
            </Button>
      </div>
    </React.Fragment>
  );
};

export default KenoGameRTPForm;
